import { clean } from './profile-seo.js';

const httpUrl = (value) => {
    const text = clean(value);
    return /^https?:\/\/\S+$/i.test(text) ? text : '';
};

// Google's article structured data asks for 16:9, 4:3 and 1:1, widest first.
const RATIOS = ['16x9', '4x3', '1x1'];

// The story's lead image as the page and its metadata use it, or null when it
// has none (or no alt text, which the API requires with every image).
export function leadImage(story) {
    const url = httpUrl(story?.leadImageUrl);
    const alt = clean(story?.leadImageAlt);
    if (!url || !alt) {
        return null;
    }
    const crops = story.leadImageCrops || {};
    return {
        wide: httpUrl(crops['16x9']),
        url,
        alt,
        width: Number(story.leadImageWidth) || undefined,
        height: Number(story.leadImageHeight) || undefined,
        caption: clean(story.leadImageCaption),
        credit: clean(story.leadImageCredit),
        crops: RATIOS.map((ratio) => httpUrl(crops[ratio])).filter(Boolean),
    };
}

// NewsArticle image: the three crops, or the one copy when they are missing.
export const leadImageSchema = (image) =>
    image.crops.length ? image.crops : [image.url];

// og:image is the 16:9 crop, 1200x675 by construction, so the share card shows
// a predictable picture whatever the photo's own shape.
export const leadImageOg = (image) =>
    image.wide
        ? { url: image.wide, width: 1200, height: 675, alt: image.alt }
        : {
              url: image.url,
              width: image.width,
              height: image.height,
              alt: image.alt,
          };
